var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.sdkError)?_c('div',{staticClass:"fixed top-0 left-0 w-full bg-red-100 text-red-700 text-center py-2 z-50"},[_vm._v(" SDK 로드에 실패했습니다. 새로고침 후 다시 시도하세요. ")]):_vm._e(),_c('router-view'),_c('portal-target',{attrs:{"name":"modals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }